import { isFunction } from 'lodash';

import { store as Auth } from './auth';
import Tutorials from './tutorials';
import { store as CatMain } from './cat-main';
import { store as CatAssignment } from './cat-assignment';
import { store as CatDomain } from './cat-domain';
import { store as CatProficiency } from './cat-proficiency';
import { store as VideoLecture } from './video-lecture';
import { store as CardLecture } from './card-lecture';
import { store as Bookmark } from './bookmark';
import { store as Course } from './course';
import { store as DomainLecture } from './domain-lecture';
import { store as UserLicence } from './user-licence';

const store = {
  Tutorials,
  Auth,
  CatMain,
  CatAssignment,
  CatDomain,
  CatProficiency,
  VideoLecture,
  CardLecture,
  Bookmark,
  Course,
  DomainLecture,
  UserLicence,
};
const keys = Object.keys(store);

const modules = keys.reduce((acc, key) => ({ ...acc, [key]: store[key].module }), {});
const plugins = keys.reduce((acc, key) => [...acc, store[key].plugin], []).filter(isFunction);

export default { modules, plugins };



// WEBPACK FOOTER //
// ./src/app/store.js